import './index.scss'
$("#nav7").addClass('active');
import Swiper from 'swiper/swiper-bundle.min.js'
var honor = new Swiper('.swiper-container', {
    slidesPerView: 3,
    spaceBetween: 30,
    centeredSlides: true,
    loop: true,
    pagination: {
        el: ".swiper-pagination",
        //自定义分页器样式
        type:"custom",
        renderCustom: function (swiper, current, total) {
            var dangqian = document.querySelector(".dangqian")
            var zongshu = document.querySelector(".zongshu")
            if(current<=9){
                current = "0"+current
            }else{
                current = current
            }
            if(total<=9){
                total = "0"+total
            }else{
            total = total
            }
            dangqian.innerText = current
            zongshu.innerText = total
        }
    },
    navigation: {
        nextEl: '.swiper-btn .swiper-button-next',
        prevEl: '.swiper-btn .swiper-button-prev',
    },
    breakpoints: {
        320: { //当屏幕宽度大于等于320
        slidesPerView: 1,
        spaceBetween: 0,
        },
        768: { //当屏幕宽度大于等于768 
            slidesPerView: 3,
            spaceBetween: 15,
        },
        1280: { //当屏幕宽度大于等于1280
            slidesPerView: 3,
            spaceBetween: 30,
        }
    },
});